// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-3p2i0";
var _3 = "notification-1QC9e";
var _4 = "notification__global-3EjHl";
var _5 = "notification__title-2MdgP";
var _6 = "notification__text-2S2e0";
export { _1 as "__esModule", _2 as "wrapper", _3 as "notification", _4 as "notification__global", _5 as "notification__title", _6 as "notification__text" }
export default { "__esModule": _1, "wrapper": _2, "notification": _3, "notification__global": _4, "notification__title": _5, "notification__text": _6 }
